$(document).ready(function() {
    let isAnimating = false;
    
    
    $('.levogr-step-six__tab[data-levo-tab]').on('click touchstart', function(event) {

         // Prevent duplicate event firing (touchstart followed by click)
         if (event.type === 'touchstart') {
            $(this).data('touchFired', true);
        } else if ($(this).data('touchFired')) {
            $(this).data('touchFired', false);
            return;
        }

        if (isAnimating) return; //Prevent multiple clicks
        
        const tabIndex = $(this).data('levo-tab');
        const $clickedTab = $(this);
        
        if ($clickedTab.hasClass('levogr-step-six__tab--active')) return;
        
        isAnimating = true;
        
     
        $('.levogr-step-six__tab-content--active').fadeOut(200, function() {
            // Remover clase activa de todos los tabs
            $('.levogr-step-six__tab').removeClass('levogr-step-six__tab--active');
            
            // Agregar clase activa al tab clickeado
            $clickedTab.addClass('levogr-step-six__tab--active');
            
            // Remover clase activa de todo el contenido
            $('.levogr-step-six__tab-content').removeClass('levogr-step-six__tab-content--active');
            
            // Mostrar el nuevo contenido con animación
            const $newContent = $(`.levogr-step-six__tab-content[data-levo-content="${tabIndex}"]`);
            $newContent.addClass('levogr-step-six__tab-content--active');
            
            // Fade in del nuevo contenido
            $newContent.hide().fadeIn(300, function() {
                // Remover efecto shimmer
                $('.levogr-step-six__image-container').removeClass('levogr-step-six__image-container--loading');
                isAnimating = false;
            });
        });
        
        // Efecto visual en el tab clickeado
        $clickedTab.css('transform', 'scale(0.95)');
        setTimeout(() => {
            $clickedTab.css('transform', '');
        }, 150);
        
        // Agregar efecto de ondas (ripple effect)
        createRippleEffect($clickedTab, event);
    });
    
    // Función para crear efecto de ondas
    function createRippleEffect($element, event) {
        const $ripple = $('<span class="ripple"></span>');
        const elementRect = $element[0].getBoundingClientRect();
        const size = Math.max(elementRect.width, elementRect.height);
        const x = event.clientX - elementRect.left - size / 2;
        const y = event.clientY - elementRect.top - size / 2;
        
        $ripple.css({
            width: size + 'px',
            height: size + 'px',
            left: x + 'px',
            top: y + 'px'
        });
        
        $element.css('position', 'relative').css('overflow', 'hidden').append($ripple);
        
        setTimeout(() => {
            $ripple.remove();
        }, 600);
    }
    
    // Navegación por teclado mejorada
    $('.levogr-step-six__tab[data-levo-tab]').on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).click();
        }
        
        // Navegación con flechas
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            e.preventDefault();
            const $tabs = $('.levogr-step-six__tab[data-levo-tab]');
            const currentIndex = $tabs.index(this);
            let newIndex;
            
            if (e.key === 'ArrowLeft') {
                newIndex = currentIndex > 0 ? currentIndex - 1 : $tabs.length - 1;
            } else {
                newIndex = currentIndex < $tabs.length - 1 ? currentIndex + 1 : 0;
            }
            
            $tabs.eq(newIndex).focus().click();
        }
    });

});

